<div class="content-container">
    <div class="ltms-description">{{ mainDiscription }}</div>
    <div class="content-container-child">
        <div class="left-box-container">
            <div class="left-box-upper">
                <app-action-ageing-actionable-issue-count [totalResponses]="totalResponses" [totalActionableResponses]="totalActionableResponses"></app-action-ageing-actionable-issue-count>
            </div>
            <div class="left-box-lower" [id]="summaryTableComponentId">
                <app-action-ageing-actionable-issue-summary [overallQuery]="overallData.query" [overallData]="overallData.data" [elementId]="summaryTableComponentId" (onDrilldownChange)="onDrilldownChange($event)"></app-action-ageing-actionable-issue-summary>
            </div>
        </div>
        <div class="right-container">
            <div class="right-upper-box" [id]="trendChartComponentId">
                <app-action-ageing-actionable-issue-trend-chart [filters]="filterObj" [componentId] = "trendChartComponentId"></app-action-ageing-actionable-issue-trend-chart>
            </div>  
            <div class="right-lower-box" [id]="barChartComponentId">
                <app-action-ageing-actionable-issue-bar-chart [filters]="filterObj" [componentId] = "barChartComponentId"></app-action-ageing-actionable-issue-bar-chart>
            </div>
        </div>
    </div>
</div>